import { getDeviceByControl, getLightColors } from './Device';
import { dataSource } from '../../Functions';
import { ControlConfig, HardwareConfigRecord } from '../documents/HardwareConfig';

export const getLightControlColors = function(control:ControlConfig, config:HardwareConfigRecord) {
    config = config || dataSource.getCurrentConfig() as HardwareConfigRecord;
    const device = getDeviceByControl(control.UUID, config);
    if (!device) {
        return false;
    }
    return device ? getLightColors(device) : false;
}
